import React, { useEffect, useState } from "react";
import styled from "./Instruction.module.scss";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { constructOrderDate } from "../../helper/DateFormatter";
import { SyncOutlined } from "@ant-design/icons";
import axiosClient from "../../service/axios";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import Reason from "../modalInstruction/Reason";
import Flag from "../modalInstruction/Flag";

const ProcessFailedItems = ({}) => {
  const { id } = useParams();
  const location = useLocation();
  const [reason, setReason] = React.useState(false);
  const [flag, setFlag] = React.useState(false);
  const { quipOrStock, tym, name, address } = location.state || {};
  const [errorMessage, setErrorMessage] = useState("");

  // console.log("quipOrStock", quipOrStock);
  // console.log("tym", tym);
  // console.log("name", name);
  // console.log("address", address);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [items, setItems] = useState([]);

  // console.log("data", data);

  const declineHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosClient.get(
        `lite/v2/api/admin/bid/list/items/${id}`
      );

      const responseData = response?.data?.data;
      const responseItems = response?.data?.items;

      if (response?.data?.status === 404) {
        setErrorMessage(response?.data?.message || "No items found.");
        setItems([]);
      } else {
        setErrorMessage("");
        setItems(responseItems);
        setData(responseData);
      }

      setLoading(false);
    } catch (error) {
      console.log("error is decline", error);
      setErrorMessage("Something went wrong. Please try again later.");
      setLoading(false);
    }
  };

  useEffect(() => {
    declineHandler();
  }, []);

  useEffect(() => {
    setReason(true);
  }, []);

  const color = () => {
    if (quipOrStock === "stock") return "#78A55A";
    if (quipOrStock === "quip") return "#c7460f";
    return "#F0FDE0";
  };

  // function delay(ms) {
  //   return new Promise((resolve) => {
  //     setTimeout(resolve, ms);
  //   });
  // }

  const processHandler = async () => {
    try {
      setLoading(true);
      const res = await axiosClient.post(
        `lite/v2/api/admin/bids/passtoOPS/${id}`
      );
      if (res.status === 200) {
        setLoading(false);
        // successAlert();
        setFlag(true);
        // failToast();
        // delay(2000);
        // navigate("/failed-bids");
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="mt-3 mb-5">
        <div className={` d-flex flex-column justify-content-center`}>
          <div className="d-flex justify-content-between mt-3 mb-3">
            <p className={styled.header} style={{ color: color() }}>
              ORDER DETAILS{" | "}
              <span>{`SBO ${id}`}</span>
            </p>
            <p
              // className={styled.name}
              style={{
                // background: bgColor(),
                color: color(),
                textTransform: "uppercase",
                cursor: "pointer",
              }}
            >
              <IoArrowBackCircleSharp size={30} onClick={() => navigate(-1)} />
              {/* {data?.title} */}
            </p>
          </div>
          <div style={{ maxHeight: "65vh", overflowY: "scroll" }}>
            <div className={styled.modalContainer2}>
              <p className={styled.title}>item(s)</p>
              <p className={styled.title}>QUANTITY</p>
              <p className={styled.title}>Brand</p>
              <p className={styled.title}>type</p>
            </div>

            <div className={styled.stockContainer}>
              {errorMessage ? (
                <p
                  style={{
                    color: "#888",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginTop: "1rem",
                  }}
                >
                  {errorMessage}
                </p>
              ) : (
                items?.map((p, index) => (
                  <div key={index} className={styled.stock}>
                    <p className={styled.title}>{p.name}</p>
                    <div className={styled.line}></div>
                    <p className={styled.title}>{p.qty}</p>
                    <div className={styled.line}></div>
                    <p className={styled.title}>{p.brand ? p.brand : "N/A"}</p>
                    <div className={styled.content}></div>
                    <p className={styled.content}>
                      {p.quantitytype ? p.quantitytype : "N/A"}
                    </p>
                  </div>
                ))
              )}
            </div>

            <div className={`${styled.modalContainer1} mt-4`}>
              <p className={styled.title}>total product count</p>
              <div className={styled.line}></div>
              <p className={styled.content}>{items.length}</p>
            </div>

            <div>
              <div className={styled.modalContainer1}>
                <p className={styled.title}>hospital name</p>
                <div className={styled.line}></div>
                <p className={styled.content}>{name ? name : "N/A"}</p>
              </div>
              <div className={styled.modalContainer1}>
                <p className={styled.title}>hospital address</p>
                <div className={styled.line}></div>
                <p className={styled.content}>{address ? address : "N/A"}</p>
              </div>
              <div className={styled.modalContainer1}>
                <p className={styled.title}>order time</p>
                <div className={styled.line}></div>
                <p className={styled.content}>{tym}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <button
              className={` shadow-none ${styled.actionBtn} ${styled.reject}`}
              style={{ background: color() }}
              onClick={processHandler}
            >
              {loading ? <SyncOutlined spin /> : `SEND TO VENDOR SUCCESS`}
            </button>
          </div>
        </div>
      </div>

      <Reason reason={reason} setReason={setReason} />
      <Flag flag={flag} setFlag={setFlag} />
    </>
  );
};

export default ProcessFailedItems;
